import {Base} from "@/api/Base"

export class OvertimeApplicationApproveNew extends Base {
    path = "overtimeApplication/approveNew"
}